import { FusawarePermission } from "@/frontend/fusawareUser";

export enum TestMethod {
  VERIFORM_PROCEDURE = 'veriformProcedure',
  DOCUMENTATION = 'documentation'
}


export const TEST_METHOD_OPTIONS = [
  { value: TestMethod.VERIFORM_PROCEDURE, labelKey: 'runProcedure', permission: FusawarePermission.ACCESS_PROCEDURE_REQUIREMENT_TEST_METHOD },
  { value: TestMethod.DOCUMENTATION, labelKey: 'provideDocumentationAsEvidence', permission: null },
];

export interface RequirementTestMethodAssignmentParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  testMethod: TestMethod;
}

export interface RequirementTestMethodAssignmentData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  requirementId: string;
  testMethod: TestMethod;
}

export type RequirementTestMethodAssignmentCreateData = Omit<RequirementTestMethodAssignmentData, 'id' | 'createdAt' | 'updatedAt'>;
